import {caseInsensitiveSort} from "../../common/Utils";
const selected=(data)=>{
    if(data)
    return "green"
    
    }
export const aclAuditColumns = [
    {
        name: 'Log Id',
        minWidth:"120px",
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.logId}</div>,
        sortable: true,
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"120px",
        },
        sortFunction: (rowA, rowB, direction) => {
          const a = rowA.logId;
          const b = rowB.logId;

          if (direction === 'asc') {
            return b - a;
          } else {
            return a - b;
          }
        },
        // headerStyle: {
        //      //width:"90px",
		//  	 justifyContent: "center",
        //      textAlign:"center",
        //       minWidth:"120px",
		//  },
    },
     {
        name: 'User Name',
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.userName}</div>,
        sortable: true,
        minWidth:"220px",
        center:true,
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) =>row.userName? row.userName: ""),
        style: {
            justifyContent: "center",
            textAlign:"center",
             minWidth:"220px",
        },
    },
    {
        name: 'Care Facility',
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.careFacilityName}</div>,
        sortable: true,
        minWidth:"230px",
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center",
             minWidth:"230px",
        },
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) =>row.careFacilityName? row.careFacilityName: ""),
    },
    {
        name: 'Old Value',
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.oldRoleName}</div>,
        sortable: true,
        
        minWidth:"120px",
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center",
             minWidth:"120px",
        },
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) =>row.oldRoleName? row.oldRoleName: ""),
    },
    {
        name: 'New Value',
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.newRoleName}</div>,
        sortable: true,
        
        minWidth:"120px",
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center",
             minWidth:"120px",
        },
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) =>row.newRoleName? row.newRoleName: ""),
    },
    {
        name: 'Updated By',
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedBy}</div>,
        sortable: true,
        minWidth:"230px",
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"230px",
        },
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedBy? row.updatedBy:""),
    },
    {
        name: 'Updated Date',
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedAt}</div>,
        sortable: true,
        minWidth:"180px",
        center:true,
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedAt? row.updatedAt:""),
        style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"180px",
        },
    }    
];

export const aclAuditExcelColumns = [
    {
        header: 'Log Id',
        key: 'logId',
    },
    {
        header: 'User Name',
        key: 'userName',
    },
    {
        header: 'Care Facility',
        key: 'careFacilityName',
    },
    {
        header: 'Old Value',
        key: 'oldRoleName',
    },
    {
        header: 'New Value',
        key: 'newRoleName',
    },
    {
        header: 'Updated By',
        key: 'updatedBy',
    },
    {
        header: 'Updated Date',
        key: 'updatedAt',
    },
];


